export const DISPLAY_DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_DATE_FORMAT = 'MM-DD-YYYY';
